import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/diet-settings/all/',
    redirectTo: '/diet-settings/all/diet-type',
  },
];

export default redirects;
